import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const IframeableCtx = /*#__PURE__*/createContext(null);
export function IframeableContextProvider({
  iframeableContext,
  children
}) {
  return /*#__PURE__*/_jsx(IframeableCtx.Provider, {
    value: iframeableContext,
    children: children
  });
}
export function useIframeableContext() {
  return useContext(IframeableCtx);
}